import AdSense from "../AdSense/AdSense";
import "./AdSection.sass";

function AdSection({
    adSlot,
    adFormat = "auto",
    adLayout,
    fullWidthResponsive,
    className = "",
    minHeight = 90,
}) {
    const shouldUseFullWidthResponsive = fullWidthResponsive ?? adFormat === "auto";

    return (
        <section className={`ad-section ${className}`.trim()} aria-label="Publicitate">
            <AdSense
                adSlot={adSlot}
                adFormat={adFormat}
                adLayout={adLayout}
                fullWidthResponsive={shouldUseFullWidthResponsive}
                style={{ minHeight }}
            />
        </section>
    );
}

export default AdSection;
